(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".clay-quantity-grid-table-container {\n  width: 100%;\n}\n\n.clay-quantity-grid-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  /* font-size: 13px; */\n  border: 1px solid #242833bf;\n  margin-bottom: 8px;\n  margin-top: 12px;\n}\n\n.clay-quantity-grid-table thead th {\n  border-bottom: 1px solid #242833bf;\n  padding: 8px;\n  text-align: left;\n  font-weight: normal;\n  /* background-color: #f0f0f0; */\n}\n\n.clay-quantity-grid-table tbody td {\n  padding: 8px;\n  border-bottom: 1px solid #242833bf;\n}\n\n.clay-quantity-grid-table tbody tr:last-child td {\n  border-bottom: none;\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
!function() {
  "use strict";
  var e, t, r, n, o, i, a, c, l, s, u, p = {}, d = [], _ = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, f = Array.isArray;
  function y(e2, t2) {
    for (var r2 in t2) e2[r2] = t2[r2];
    return e2;
  }
  function h(e2) {
    e2 && e2.parentNode && e2.parentNode.removeChild(e2);
  }
  function m(e2, n2, o2, i2, a2) {
    var c2 = { type: e2, props: n2, key: o2, ref: i2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == a2 ? ++r : a2, __i: -1, __u: 0 };
    return null == a2 && null != t.vnode && t.vnode(c2), c2;
  }
  function g(e2) {
    return e2.children;
  }
  function v(e2, t2) {
    this.props = e2, this.context = t2;
  }
  function b(e2, t2) {
    if (null == t2) return e2.__ ? b(e2.__, e2.__i + 1) : null;
    for (var r2; t2 < e2.__k.length; t2++) if (null != (r2 = e2.__k[t2]) && null != r2.__e) return r2.__e;
    return "function" == typeof e2.type ? b(e2) : null;
  }
  function F(e2) {
    var t2, r2;
    if (null != (e2 = e2.__) && null != e2.__c) {
      for (e2.__e = e2.__c.base = null, t2 = 0; t2 < e2.__k.length; t2++) if (null != (r2 = e2.__k[t2]) && null != r2.__e) {
        e2.__e = e2.__c.base = r2.__e;
        break;
      }
      return F(e2);
    }
  }
  function w(e2) {
    (!e2.__d && (e2.__d = true) && n.push(e2) && !$.__r++ || o !== t.debounceRendering) && ((o = t.debounceRendering) || i)($);
  }
  function $() {
    for (var e2, r2, o2, i2, c2, l2, s2, u2 = 1; n.length; ) n.length > u2 && n.sort(a), e2 = n.shift(), u2 = n.length, e2.__d && (o2 = void 0, c2 = (i2 = (r2 = e2).__v).__e, l2 = [], s2 = [], r2.__P && ((o2 = y({}, i2)).__v = i2.__v + 1, t.vnode && t.vnode(o2), q(r2.__P, o2, i2, r2.__n, r2.__P.namespaceURI, 32 & i2.__u ? [c2] : null, l2, null == c2 ? b(i2) : c2, !!(32 & i2.__u), s2), o2.__v = i2.__v, o2.__.__k[o2.__i] = o2, I(l2, o2, s2), o2.__e != c2 && F(o2)));
    $.__r = 0;
  }
  function P(e2, t2, r2, n2, o2, i2, a2, c2, l2, s2, u2) {
    var _2, f2, y2, h2, m2, g2, v2 = n2 && n2.__k || d, b2 = t2.length;
    for (l2 = k(r2, t2, v2, l2, b2), _2 = 0; _2 < b2; _2++) null != (y2 = r2.__k[_2]) && (f2 = -1 === y2.__i ? p : v2[y2.__i] || p, y2.__i = _2, g2 = q(e2, y2, f2, o2, i2, a2, c2, l2, s2, u2), h2 = y2.__e, y2.ref && f2.ref != y2.ref && (f2.ref && E(f2.ref, null, y2), u2.push(y2.ref, y2.__c || h2, y2)), null == m2 && null != h2 && (m2 = h2), 4 & y2.__u || f2.__k === y2.__k ? l2 = S(y2, l2, e2) : "function" == typeof y2.type && void 0 !== g2 ? l2 = g2 : h2 && (l2 = h2.nextSibling), y2.__u &= -7);
    return r2.__e = m2, l2;
  }
  function k(e2, t2, r2, n2, o2) {
    var i2, a2, c2, l2, s2, u2 = r2.length, p2 = u2, d2 = 0;
    for (e2.__k = new Array(o2), i2 = 0; i2 < o2; i2++) null != (a2 = t2[i2]) && "boolean" != typeof a2 && "function" != typeof a2 ? (l2 = i2 + d2, (a2 = e2.__k[i2] = "string" == typeof a2 || "number" == typeof a2 || "bigint" == typeof a2 || a2.constructor == String ? m(null, a2, null, null, null) : f(a2) ? m(g, { children: a2 }, null, null, null) : void 0 === a2.constructor && a2.__b > 0 ? m(a2.type, a2.props, a2.key, a2.ref ? a2.ref : null, a2.__v) : a2).__ = e2, a2.__b = e2.__b + 1, c2 = null, -1 !== (s2 = a2.__i = C(a2, r2, l2, p2)) && (p2--, (c2 = r2[s2]) && (c2.__u |= 2)), null == c2 || null === c2.__v ? (-1 == s2 && (o2 > u2 ? d2-- : o2 < u2 && d2++), "function" != typeof a2.type && (a2.__u |= 4)) : s2 != l2 && (s2 == l2 - 1 ? d2-- : s2 == l2 + 1 ? d2++ : (s2 > l2 ? d2-- : d2++, a2.__u |= 4))) : e2.__k[i2] = null;
    if (p2) for (i2 = 0; i2 < u2; i2++) null != (c2 = r2[i2]) && !(2 & c2.__u) && (c2.__e == n2 && (n2 = b(c2)), O(c2, c2));
    return n2;
  }
  function S(e2, t2, r2) {
    var n2, o2;
    if ("function" == typeof e2.type) {
      for (n2 = e2.__k, o2 = 0; n2 && o2 < n2.length; o2++) n2[o2] && (n2[o2].__ = e2, t2 = S(n2[o2], t2, r2));
      return t2;
    }
    e2.__e != t2 && (t2 && e2.type && !r2.contains(t2) && (t2 = b(e2)), r2.insertBefore(e2.__e, t2 || null), t2 = e2.__e);
    do {
      t2 = t2 && t2.nextSibling;
    } while (null != t2 && 8 == t2.nodeType);
    return t2;
  }
  function C(e2, t2, r2, n2) {
    var o2, i2, a2 = e2.key, c2 = e2.type, l2 = t2[r2];
    if (null === l2 && null == e2.key || l2 && a2 == l2.key && c2 === l2.type && !(2 & l2.__u)) return r2;
    if (n2 > (null == l2 || 2 & l2.__u ? 0 : 1)) for (o2 = r2 - 1, i2 = r2 + 1; o2 >= 0 || i2 < t2.length; ) {
      if (o2 >= 0) {
        if ((l2 = t2[o2]) && !(2 & l2.__u) && a2 == l2.key && c2 === l2.type) return o2;
        o2--;
      }
      if (i2 < t2.length) {
        if ((l2 = t2[i2]) && !(2 & l2.__u) && a2 == l2.key && c2 === l2.type) return i2;
        i2++;
      }
    }
    return -1;
  }
  function x(e2, t2, r2) {
    "-" == t2[0] ? e2.setProperty(t2, null == r2 ? "" : r2) : e2[t2] = null == r2 ? "" : "number" != typeof r2 || _.test(t2) ? r2 : r2 + "px";
  }
  function A(e2, t2, r2, n2, o2) {
    var i2;
    e: if ("style" == t2) if ("string" == typeof r2) e2.style.cssText = r2;
    else {
      if ("string" == typeof n2 && (e2.style.cssText = n2 = ""), n2) for (t2 in n2) r2 && t2 in r2 || x(e2.style, t2, "");
      if (r2) for (t2 in r2) n2 && r2[t2] === n2[t2] || x(e2.style, t2, r2[t2]);
    }
    else if ("o" == t2[0] && "n" == t2[1]) i2 = t2 != (t2 = t2.replace(c, "$1")), t2 = t2.toLowerCase() in e2 || "onFocusOut" == t2 || "onFocusIn" == t2 ? t2.toLowerCase().slice(2) : t2.slice(2), e2.l || (e2.l = {}), e2.l[t2 + i2] = r2, r2 ? n2 ? r2.t = n2.t : (r2.t = l, e2.addEventListener(t2, i2 ? u : s, i2)) : e2.removeEventListener(t2, i2 ? u : s, i2);
    else {
      if ("http://www.w3.org/2000/svg" == o2) t2 = t2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" != t2 && "height" != t2 && "href" != t2 && "list" != t2 && "form" != t2 && "tabIndex" != t2 && "download" != t2 && "rowSpan" != t2 && "colSpan" != t2 && "role" != t2 && "popover" != t2 && t2 in e2) try {
        e2[t2] = null == r2 ? "" : r2;
        break e;
      } catch (e3) {
      }
      "function" == typeof r2 || (null == r2 || false === r2 && "-" != t2[4] ? e2.removeAttribute(t2) : e2.setAttribute(t2, "popover" == t2 && 1 == r2 ? "" : r2));
    }
  }
  function T(e2) {
    return function(r2) {
      if (this.l) {
        var n2 = this.l[r2.type + e2];
        if (null == r2.u) r2.u = l++;
        else if (r2.u < n2.t) return;
        return n2(t.event ? t.event(r2) : r2);
      }
    };
  }
  function q(e2, r2, n2, o2, i2, a2, c2, l2, s2, u2) {
    var p2, d2, _2, m2, b2, F2, w2, k2, S2, C2, x2, $2, A2, T2, q2, I2, E2, O2 = r2.type;
    if (void 0 !== r2.constructor) return null;
    128 & n2.__u && (s2 = !!(32 & n2.__u), a2 = [l2 = r2.__e = n2.__e]), (p2 = t.__b) && p2(r2);
    e: if ("function" == typeof O2) try {
      if (k2 = r2.props, S2 = "prototype" in O2 && O2.prototype.render, C2 = (p2 = O2.contextType) && o2[p2.__c], x2 = p2 ? C2 ? C2.props.value : p2.__ : o2, n2.__c ? w2 = (d2 = r2.__c = n2.__c).__ = d2.__E : (S2 ? r2.__c = d2 = new O2(k2, x2) : (r2.__c = d2 = new v(k2, x2), d2.constructor = O2, d2.render = R), C2 && C2.sub(d2), d2.props = k2, d2.state || (d2.state = {}), d2.context = x2, d2.__n = o2, _2 = d2.__d = true, d2.__h = [], d2._sb = []), S2 && null == d2.__s && (d2.__s = d2.state), S2 && null != O2.getDerivedStateFromProps && (d2.__s == d2.state && (d2.__s = y({}, d2.__s)), y(d2.__s, O2.getDerivedStateFromProps(k2, d2.__s))), m2 = d2.props, b2 = d2.state, d2.__v = r2, _2) S2 && null == O2.getDerivedStateFromProps && null != d2.componentWillMount && d2.componentWillMount(), S2 && null != d2.componentDidMount && d2.__h.push(d2.componentDidMount);
      else {
        if (S2 && null == O2.getDerivedStateFromProps && k2 !== m2 && null != d2.componentWillReceiveProps && d2.componentWillReceiveProps(k2, x2), !d2.__e && (null != d2.shouldComponentUpdate && false === d2.shouldComponentUpdate(k2, d2.__s, x2) || r2.__v == n2.__v)) {
          for (r2.__v != n2.__v && (d2.props = k2, d2.state = d2.__s, d2.__d = false), r2.__e = n2.__e, r2.__k = n2.__k, r2.__k.some(function(e3) {
            e3 && (e3.__ = r2);
          }), $2 = 0; $2 < d2._sb.length; $2++) d2.__h.push(d2._sb[$2]);
          d2._sb = [], d2.__h.length && c2.push(d2);
          break e;
        }
        null != d2.componentWillUpdate && d2.componentWillUpdate(k2, d2.__s, x2), S2 && null != d2.componentDidUpdate && d2.__h.push(function() {
          d2.componentDidUpdate(m2, b2, F2);
        });
      }
      if (d2.context = x2, d2.props = k2, d2.__P = e2, d2.__e = false, A2 = t.__r, T2 = 0, S2) {
        for (d2.state = d2.__s, d2.__d = false, A2 && A2(r2), p2 = d2.render(d2.props, d2.state, d2.context), q2 = 0; q2 < d2._sb.length; q2++) d2.__h.push(d2._sb[q2]);
        d2._sb = [];
      } else do {
        d2.__d = false, A2 && A2(r2), p2 = d2.render(d2.props, d2.state, d2.context), d2.state = d2.__s;
      } while (d2.__d && ++T2 < 25);
      d2.state = d2.__s, null != d2.getChildContext && (o2 = y(y({}, o2), d2.getChildContext())), S2 && !_2 && null != d2.getSnapshotBeforeUpdate && (F2 = d2.getSnapshotBeforeUpdate(m2, b2)), I2 = p2, null != p2 && p2.type === g && null == p2.key && (I2 = N(p2.props.children)), l2 = P(e2, f(I2) ? I2 : [I2], r2, n2, o2, i2, a2, c2, l2, s2, u2), d2.base = r2.__e, r2.__u &= -161, d2.__h.length && c2.push(d2), w2 && (d2.__E = d2.__ = null);
    } catch (e3) {
      if (r2.__v = null, s2 || null != a2) if (e3.then) {
        for (r2.__u |= s2 ? 160 : 128; l2 && 8 == l2.nodeType && l2.nextSibling; ) l2 = l2.nextSibling;
        a2[a2.indexOf(l2)] = null, r2.__e = l2;
      } else for (E2 = a2.length; E2--; ) h(a2[E2]);
      else r2.__e = n2.__e, r2.__k = n2.__k;
      t.__e(e3, r2, n2);
    }
    else null == a2 && r2.__v == n2.__v ? (r2.__k = n2.__k, r2.__e = n2.__e) : l2 = r2.__e = j(n2.__e, r2, n2, o2, i2, a2, c2, s2, u2);
    return (p2 = t.diffed) && p2(r2), 128 & r2.__u ? void 0 : l2;
  }
  function I(e2, r2, n2) {
    for (var o2 = 0; o2 < n2.length; o2++) E(n2[o2], n2[++o2], n2[++o2]);
    t.__c && t.__c(r2, e2), e2.some(function(r3) {
      try {
        e2 = r3.__h, r3.__h = [], e2.some(function(e3) {
          e3.call(r3);
        });
      } catch (e3) {
        t.__e(e3, r3.__v);
      }
    });
  }
  function N(e2) {
    return "object" != typeof e2 || null == e2 ? e2 : f(e2) ? e2.map(N) : y({}, e2);
  }
  function j(r2, n2, o2, i2, a2, c2, l2, s2, u2) {
    var d2, _2, y2, m2, g2, v2, F2, w2 = o2.props, k2 = n2.props, S2 = n2.type;
    if ("svg" == S2 ? a2 = "http://www.w3.org/2000/svg" : "math" == S2 ? a2 = "http://www.w3.org/1998/Math/MathML" : a2 || (a2 = "http://www.w3.org/1999/xhtml"), null != c2) {
      for (d2 = 0; d2 < c2.length; d2++) if ((g2 = c2[d2]) && "setAttribute" in g2 == !!S2 && (S2 ? g2.localName == S2 : 3 == g2.nodeType)) {
        r2 = g2, c2[d2] = null;
        break;
      }
    }
    if (null == r2) {
      if (null == S2) return document.createTextNode(k2);
      r2 = document.createElementNS(a2, S2, k2.is && k2), s2 && (t.__m && t.__m(n2, c2), s2 = false), c2 = null;
    }
    if (null === S2) w2 === k2 || s2 && r2.data === k2 || (r2.data = k2);
    else {
      if (c2 = c2 && e.call(r2.childNodes), w2 = o2.props || p, !s2 && null != c2) for (w2 = {}, d2 = 0; d2 < r2.attributes.length; d2++) w2[(g2 = r2.attributes[d2]).name] = g2.value;
      for (d2 in w2) if (g2 = w2[d2], "children" == d2) ;
      else if ("dangerouslySetInnerHTML" == d2) y2 = g2;
      else if (!(d2 in k2)) {
        if ("value" == d2 && "defaultValue" in k2 || "checked" == d2 && "defaultChecked" in k2) continue;
        A(r2, d2, null, g2, a2);
      }
      for (d2 in k2) g2 = k2[d2], "children" == d2 ? m2 = g2 : "dangerouslySetInnerHTML" == d2 ? _2 = g2 : "value" == d2 ? v2 = g2 : "checked" == d2 ? F2 = g2 : s2 && "function" != typeof g2 || w2[d2] === g2 || A(r2, d2, g2, w2[d2], a2);
      if (_2) s2 || y2 && (_2.__html === y2.__html || _2.__html === r2.innerHTML) || (r2.innerHTML = _2.__html), n2.__k = [];
      else if (y2 && (r2.innerHTML = ""), P("template" === n2.type ? r2.content : r2, f(m2) ? m2 : [m2], n2, o2, i2, "foreignObject" == S2 ? "http://www.w3.org/1999/xhtml" : a2, c2, l2, c2 ? c2[0] : o2.__k && b(o2, 0), s2, u2), null != c2) for (d2 = c2.length; d2--; ) h(c2[d2]);
      s2 || (d2 = "value", "progress" == S2 && null == v2 ? r2.removeAttribute("value") : void 0 !== v2 && (v2 !== r2[d2] || "progress" == S2 && !v2 || "option" == S2 && v2 !== w2[d2]) && A(r2, d2, v2, w2[d2], a2), d2 = "checked", void 0 !== F2 && F2 !== r2[d2] && A(r2, d2, F2, w2[d2], a2));
    }
    return r2;
  }
  function E(e2, r2, n2) {
    try {
      if ("function" == typeof e2) {
        var o2 = "function" == typeof e2.__u;
        o2 && e2.__u(), o2 && null == r2 || (e2.__u = e2(r2));
      } else e2.current = r2;
    } catch (e3) {
      t.__e(e3, n2);
    }
  }
  function O(e2, r2, n2) {
    var o2, i2;
    if (t.unmount && t.unmount(e2), (o2 = e2.ref) && (o2.current && o2.current !== e2.__e || E(o2, null, r2)), null != (o2 = e2.__c)) {
      if (o2.componentWillUnmount) try {
        o2.componentWillUnmount();
      } catch (e3) {
        t.__e(e3, r2);
      }
      o2.base = o2.__P = null;
    }
    if (o2 = e2.__k) for (i2 = 0; i2 < o2.length; i2++) o2[i2] && O(o2[i2], r2, n2 || "function" != typeof e2.type);
    n2 || h(e2.__e), e2.__c = e2.__ = e2.__e = void 0;
  }
  function R(e2, t2, r2) {
    return this.constructor(e2, r2);
  }
  function D(r2, n2, o2) {
    var i2, a2, c2;
    n2 == document && (n2 = document.documentElement), t.__ && t.__(r2, n2), i2 = false ? null : n2.__k, a2 = [], c2 = [], q(n2, r2 = n2.__k = function(t2, r3, n3) {
      var o3, i3, a3, c3 = {};
      for (a3 in r3) "key" == a3 ? o3 = r3[a3] : "ref" == a3 ? i3 = r3[a3] : c3[a3] = r3[a3];
      if (arguments.length > 2 && (c3.children = arguments.length > 3 ? e.call(arguments, 2) : n3), "function" == typeof t2 && null != t2.defaultProps) for (a3 in t2.defaultProps) void 0 === c3[a3] && (c3[a3] = t2.defaultProps[a3]);
      return m(t2, c3, o3, i3, null);
    }(g, null, [r2]), i2 || p, p, n2.namespaceURI, i2 ? null : n2.firstChild ? e.call(n2.childNodes) : null, a2, i2 ? i2.__e : n2.firstChild, false, c2), I(a2, r2, c2);
  }
  e = d.slice, t = { __e: function(e2, t2, r2, n2) {
    for (var o2, i2, a2; t2 = t2.__; ) if ((o2 = t2.__c) && !o2.__) try {
      if ((i2 = o2.constructor) && null != i2.getDerivedStateFromError && (o2.setState(i2.getDerivedStateFromError(e2)), a2 = o2.__d), null != o2.componentDidCatch && (o2.componentDidCatch(e2, n2 || {}), a2 = o2.__d), a2) return o2.__E = o2;
    } catch (t3) {
      e2 = t3;
    }
    throw e2;
  } }, r = 0, v.prototype.setState = function(e2, t2) {
    var r2;
    r2 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = y({}, this.state), "function" == typeof e2 && (e2 = e2(y({}, r2), this.props)), e2 && y(r2, e2), null != e2 && this.__v && (t2 && this._sb.push(t2), w(this));
  }, v.prototype.forceUpdate = function(e2) {
    this.__v && (this.__e = true, e2 && this.__h.push(e2), w(this));
  }, v.prototype.render = g, n = [], i = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, a = function(e2, t2) {
    return e2.__v.__b - t2.__v.__b;
  }, $.__r = 0, c = /(PointerCapture)$|Capture$/i, l = 0, s = T(false), u = T(true);
  var L = 0;
  function U(e2, r2, n2, o2, i2, a2) {
    r2 || (r2 = {});
    var c2, l2, s2 = r2;
    if ("ref" in s2) for (l2 in s2 = {}, r2) "ref" == l2 ? c2 = r2[l2] : s2[l2] = r2[l2];
    var u2 = { type: e2, props: s2, key: n2, ref: c2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --L, __i: -1, __u: 0, __source: i2, __self: a2 };
    if ("function" == typeof e2 && (c2 = e2.defaultProps)) for (l2 in c2) void 0 === s2[l2] && (s2[l2] = c2[l2]);
    return t.vnode && t.vnode(u2), u2;
  }
  const G = /* @__PURE__ */ new Map(), H = /* @__PURE__ */ new Map();
  let M = [], B = false, W = null;
  const V = (e2) => Date.now() - e2 > 3e5, K = async ({ shopDomain: e2, accessToken: t2, query: r2, variables: n2 }) => {
    try {
      const o2 = `https://${e2}/api/2024-07/graphql.json`, i2 = { "X-Shopify-Storefront-Access-Token": t2, "Content-Type": "application/json" }, a2 = await fetch(o2, { method: "POST", headers: i2, body: JSON.stringify({ query: r2, variables: n2 }) });
      return await a2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, J = async (e2, t2, r2, n2, o2, i2) => {
    const a2 = ((e3, t3, r3, n3, o3) => `${e3}:${t3}:${r3}:${JSON.stringify(n3)}:${o3}`)(e2, r2, n2, o2, i2), c2 = G.get(a2);
    if (c2 && !V(c2.timestamp)) return c2.data;
    const l2 = H.get(a2);
    if (l2) return l2;
    const s2 = (u2 = { shopDomain: e2, accessToken: t2, handle: r2, customerGroupId: n2, customerTags: o2, clayCountryIsoCode: i2, cacheKey: a2 }, new Promise((e3, t3) => {
      M.push({ ...u2, resolve: e3, reject: t3 }), B || (B = true, queueMicrotask(() => {
        B = false, function() {
          if (0 === M.length) return;
          const e4 = M;
          M = [];
          for (let t4 = 0; t4 < e4.length; t4 += 10) {
            const r3 = e4.slice(t4, t4 + 10), n3 = null === W, o3 = Q(r3, n3);
            n3 && (W = o3);
          }
        }();
      }));
    }));
    var u2;
    return H.set(a2, s2), s2.finally(() => {
      H.delete(a2);
    }), s2;
  };
  async function Q(e2, t2) {
    var _a, _b, _c;
    if (!t2 && W) try {
      await W;
    } catch {
    }
    const r2 = e2[0];
    try {
      const t3 = function(e3) {
        const t4 = e3.map((e4, t5) => `p${t5}: product(handle: ${JSON.stringify(e4)}) {
      title
      handle
      variants(first: 50) {
        edges {
          node {
            id
            title
            metafield(namespace: "app--173437812737--clay", key: "pricing_rule") {
              value
              type
            }
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
            availableForSale
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }`).join("\n");
        return `query batchProductMetafield($country: CountryCode) @inContext(country: $country) {
    ${t4}
  }`;
      }(e2.map((e3) => e3.handle)), n2 = await K({ shopDomain: r2.shopDomain, accessToken: r2.accessToken, query: t3, variables: { country: r2.clayCountryIsoCode } });
      if (!(n2 == null ? void 0 : n2.data)) {
        const t4 = new Error("Empty response from Storefront API");
        return void e2.forEach((e3) => e3.reject(t4));
      }
      for (let t4 = 0; t4 < e2.length; t4++) {
        const r3 = e2[t4], o2 = n2.data[`p${t4}`];
        if (!o2) {
          const e3 = { handle: r3.handle, allVariants: [] };
          G.set(r3.cacheKey, { data: e3, timestamp: Date.now() }), r3.resolve(e3);
          continue;
        }
        if ((_b = (_a = o2.variants) == null ? void 0 : _a.pageInfo) == null ? void 0 : _b.hasNextPage) {
          z(r3.shopDomain, r3.accessToken, r3.handle, r3.customerGroupId, r3.customerTags, r3.clayCountryIsoCode, r3.cacheKey).then((e3) => r3.resolve(e3)).catch(r3.reject);
          continue;
        }
        const i2 = (((_c = o2.variants) == null ? void 0 : _c.edges) || []).map((e3) => Y(e3.node, r3.customerGroupId, r3.customerTags)), a2 = { handle: r3.handle, allVariants: i2 };
        G.set(r3.cacheKey, { data: a2, timestamp: Date.now() }), r3.resolve(a2);
      }
      X();
    } catch (t3) {
      console.error("Error in batched product metafield fetch:", t3), e2.forEach((e3) => e3.reject(t3));
    }
  }
  function Y(e2, t2, r2) {
    var _a;
    const n2 = e2.id.split("/").pop(), o2 = (_a = e2.metafield) == null ? void 0 : _a.value, i2 = function(e3) {
      if (!Array.isArray(e3) || 0 === e3.length) return [];
      const t3 = e3[0];
      if ("customerGroupId" in t3) return r3 = e3, Array.isArray(r3) ? r3.map((e4 = {}) => {
        const { customerGroupId: t4 = "", customerTag: r4 = "", type: n3 = "WHOLESALE", wholesalePrice: o3 = null, quantityPrice: i3 = {} } = e4;
        let a3 = false;
        "QUANTITY" === n3 && (a3 = !!i3.isVariantUnique);
        let c3 = [];
        return "WHOLESALE" === n3 && null != o3 ? c3.push({ quantity: "1", price: o3 }) : Array.isArray(i3.value) && (c3 = i3.value), { ownerId: "", customerGroupId: t4, customerTag: r4, markets: [{ handle: "", currency: "", pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: a3, priceSource: "R", values: c3 } }] };
      }) : [];
      var r3;
      if ("i" in t3) return function(e4) {
        if (!e4 || !Array.isArray(e4)) return null;
        const t4 = e4.map((e5 = {}) => {
          let t5 = e5.o || "", [r4 = "", n3 = ""] = (e5.i || "").split("~"), o3 = e5.p.split("|").map((e6) => {
            let [t6 = "", r5 = "", n4 = "A", o4 = "0", i3 = "R", a3 = ""] = e6.split("~"), c3 = a3.split(";").map((e7) => {
              let [t7 = "1", r6 = "0"] = e7.split(":");
              return { quantity: t7, price: r6 };
            }) ?? [];
            return { handle: t6, currency: r5, pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: n4, priceSource: i3, isVariantUnique: "1" === o4, values: c3 } };
          });
          return { ownerId: t5, customerGroupId: r4, customerTag: n3, markets: o3 };
        });
        return t4;
      }(e3);
      return [];
    }("string" == typeof o2 ? JSON.parse(o2) : []);
    let a2 = i2.find((e3) => e3.customerGroupId === t2 && !["LOGGED_IN", "ALL"].includes(t2) || r2.includes(e3.customerTag));
    a2 || "ALL" === t2 || (a2 = i2.find((e3) => "LOGGED_IN" === e3.customerGroupId)), a2 || (a2 = i2.find((e3) => "ALL" === e3.customerGroupId));
    const c2 = window.clayMarketHandle;
    if (a2) {
      const t3 = a2.markets.find((e3) => e3.handle === c2 || "" === e3.handle) || null;
      if (t3) {
        const r3 = { ...a2, markets: [t3] };
        if ("" === r3.ownerId || r3.ownerId === n2.split("/").pop()) return { id: n2, title: e2.title, pricingRule: r3, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
      }
    }
    return { id: n2, title: e2.title, pricingRule: null, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
  }
  async function z(e2, t2, r2, n2, o2, i2, a2) {
    var _a, _b, _c, _d, _e2, _f, _g, _h, _i, _j;
    try {
      let c2, l2 = true;
      const s2 = [];
      for (; l2; ) {
        const u3 = await K({ shopDomain: e2, accessToken: t2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250, after: ${c2 ? `"${c2}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                    availableForSale
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: r2, country: i2 } });
        if (!((_a = u3.data) == null ? void 0 : _a.product)) {
          const e3 = { handle: r2, allVariants: [] };
          return G.set(a2, { data: e3, timestamp: Date.now() }), e3;
        }
        const p2 = (((_b = u3.data.product.variants) == null ? void 0 : _b.edges) || []).map((e3) => Y(e3.node, n2, o2));
        s2.push(...p2), l2 = (_f = (_e2 = (_d = (_c = u3.data) == null ? void 0 : _c.product) == null ? void 0 : _d.variants) == null ? void 0 : _e2.pageInfo) == null ? void 0 : _f.hasNextPage, c2 = (_j = (_i = (_h = (_g = u3.data) == null ? void 0 : _g.product) == null ? void 0 : _h.variants) == null ? void 0 : _i.pageInfo) == null ? void 0 : _j.endCursor;
      }
      const u2 = { handle: r2, allVariants: s2 };
      return G.set(a2, { data: u2, timestamp: Date.now() }), X(), u2;
    } catch (e3) {
      throw console.error("Error fetching product metafield:", e3), e3;
    }
  }
  const X = () => {
    for (const [e2, t2] of G.entries()) V(t2.timestamp) && G.delete(e2);
  };
  function Z(e2, t2) {
    if (null === e2) return "";
    const r2 = "string" == typeof e2 ? parseFloat(e2) : e2, n2 = r2.toFixed(2), o2 = r2.toFixed(0), i2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), a2 = o2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), c2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), l2 = o2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), s2 = n2.replace(".", ","), u2 = i2.replace(/(\d+)\.(\d{2})$/, "$1,$2"), p2 = c2.replace(/(\d+)\.(\d{2})$/, "$1,$2");
    return t2.replace("{{amount}}", n2).replace("{{amount_no_decimals}}", o2).replace("{{amount_with_comma_separator}}", i2).replace("{{amount_no_decimals_with_comma_separator}}", a2).replace("{{amount_with_period_separator}}", c2).replace("{{amount_no_decimals_with_period_separator}}", l2).replace("{{amount_with_comma_decimal}}", s2).replace("{{amount_with_comma_separator_and_comma_decimal}}", u2).replace("{{amount_with_period_separator_and_comma_decimal}}", p2);
  }
  function ee(e2, t2) {
    var _a;
    let r2 = "", n2 = "", o2 = "", i2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!i2) return { retailPrice: "", compareAtPrice: "", savings: "" };
    let a2 = i2.pricing.type;
    return "QUANTITY" === a2 ? { retailPrice: r2, compareAtPrice: n2, savings: o2 } = function(e3, t3, r3) {
      let n3 = r3.pricing.strategy, o3 = r3.pricing.values, i3 = r3.currency, a3 = e3.price.currencyCode, c2 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l2 = window.marketConversionRate;
      if (!c2 || "" === c2) return { retailPrice: "", compareAtPrice: "", savings: "" };
      let s2 = o3.filter((e4) => Number(e4.quantity) <= t3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (i3 !== a3 && "" !== i3) {
        if (!l2 || !l2.conversion_rate) return { retailPrice: "", compareAtPrice: "", savings: "" };
        ["A", "F"].includes(n3) && (s2 = (parseFloat(s2) * l2.conversion_rate).toFixed(2).toString());
      }
      let u2 = "A" === n3 ? s2 : "P" === n3 ? (parseFloat(c2) * (1 - parseFloat(s2) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c2) - parseFloat(s2)).toFixed(2).toString() : e3.price.amount;
      if ("" === i3 && l2 && l2.base_currency !== a3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      (parseFloat(u2) < 0 || parseFloat(u2) > parseFloat(e3.price.amount)) && (u2 = e3.price.amount);
      let p2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c2) - parseFloat(u2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c2) - parseFloat(u2)) / parseFloat(c2) * 100).toFixed(0) : 0;
      return { retailPrice: u2, compareAtPrice: parseFloat(c2).toFixed(2), savings: p2 };
    }(e2, t2, i2) : "WHOLESALE" === a2 && ({ retailPrice: r2, compareAtPrice: n2, savings: o2 } = function(e3, t3) {
      let r3 = t3.pricing.strategy;
      t3.pricing.values;
      let n3 = t3.currency, o3 = e3.price.currencyCode, i3 = window.marketConversionRate, a3 = "R" === t3.pricing.priceSource ? e3.price.amount : "C" === t3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, c2 = t3.pricing.values[0].price;
      if (!a3 || "" === a3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      if (n3 !== o3 && "" !== n3) {
        if (!i3 || !i3.conversion_rate) return { retailPrice: "", compareAtPrice: "", savings: "" };
        ["A", "F"].includes(r3) && (c2 = (parseFloat(c2) * i3.conversion_rate).toFixed(2).toString());
      }
      let l2 = "A" === r3 ? c2 : "P" === r3 ? (parseFloat(a3) * (1 - parseFloat(c2) / 100)).toFixed(2).toString() : "F" === r3 ? (parseFloat(a3) - parseFloat(c2)).toFixed(2).toString() : e3.price.amount;
      if ("" === n3 && i3 && i3.base_currency !== o3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      (parseFloat(l2) < 0 || parseFloat(l2) > parseFloat(e3.price.amount)) && (l2 = e3.price.amount);
      let s2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(a3) - parseFloat(l2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(a3) - parseFloat(l2)) / parseFloat(a3) * 100).toFixed(2) : 0;
      return { retailPrice: l2, compareAtPrice: parseFloat(a3).toFixed(2), savings: s2 };
    }(e2, i2)), { retailPrice: r2, compareAtPrice: n2, savings: o2 };
  }
  function te(e2, t2, r2, n2, o2) {
    return e2.replace("{retailPriceText}", t2).replace("{compareAtPriceText}", r2).replace("{savingsText}", n2).replace("{maxRetailPriceText}", o2);
  }
  function re(e2) {
    if (!e2 || "" === e2) return null;
    let t2 = null;
    const r2 = e2.match(/\/products\/([^/?#]+)/);
    return r2 && r2[1] && (t2 = decodeURIComponent(r2[1])), t2;
  }
  async function ne(e2) {
    const t2 = window.clayStorefrontConfig || {}, r2 = window.clayCustomerTier || {}, n2 = window.clayCustomerTags || [], o2 = window.clayCountryIsoCode, { allVariants: i2 } = await J(t2.shopDomain, t2.token, e2, "" === r2.customerGroupId ? "LOGGED_IN" : r2.customerGroupId, n2, o2);
    return i2;
  }
  const oe = "%[a-f0-9]{2}", ie = new RegExp("(" + oe + ")|([^%]+?)", "gi"), ae = new RegExp("(" + oe + ")+", "gi");
  function ce(e2, t2) {
    try {
      return [decodeURIComponent(e2.join(""))];
    } catch {
    }
    if (1 === e2.length) return e2;
    t2 = t2 || 1;
    const r2 = e2.slice(0, t2), n2 = e2.slice(t2);
    return Array.prototype.concat.call([], ce(r2), ce(n2));
  }
  function le(e2) {
    try {
      return decodeURIComponent(e2);
    } catch {
      let t2 = e2.match(ie) || [];
      for (let r2 = 1; r2 < t2.length; r2++) t2 = (e2 = ce(t2, r2).join("")).match(ie) || [];
      return e2;
    }
  }
  function se(e2) {
    if ("string" != typeof e2) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e2 + "`");
    try {
      return decodeURIComponent(e2);
    } catch {
      return function(e3) {
        const t2 = { "%FE%FF": "��", "%FF%FE": "��" };
        let r2 = ae.exec(e3);
        for (; r2; ) {
          try {
            t2[r2[0]] = decodeURIComponent(r2[0]);
          } catch {
            const e4 = le(r2[0]);
            e4 !== r2[0] && (t2[r2[0]] = e4);
          }
          r2 = ae.exec(e3);
        }
        t2["%C2"] = "�";
        const n2 = Object.keys(t2);
        for (const r3 of n2) e3 = e3.replace(new RegExp(r3, "g"), t2[r3]);
        return e3;
      }(e2);
    }
  }
  function ue(e2, t2) {
    const r2 = {};
    if (Array.isArray(t2)) for (const n2 of t2) {
      const t3 = Object.getOwnPropertyDescriptor(e2, n2);
      (t3 == null ? void 0 : t3.enumerable) && Object.defineProperty(r2, n2, t3);
    }
    else for (const n2 of Reflect.ownKeys(e2)) {
      const o2 = Object.getOwnPropertyDescriptor(e2, n2);
      if (o2.enumerable) {
        t2(n2, e2[n2], e2) && Object.defineProperty(r2, n2, o2);
      }
    }
    return r2;
  }
  function pe(e2, t2) {
    if ("string" != typeof e2 || "string" != typeof t2) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === e2 || "" === t2) return [];
    const r2 = e2.indexOf(t2);
    return -1 === r2 ? [] : [e2.slice(0, r2), e2.slice(r2 + t2.length)];
  }
  const de = Symbol("encodeFragmentIdentifier");
  function _e(e2) {
    if ("string" != typeof e2 || 1 !== e2.length) throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function fe(e2, t2) {
    return t2.encode ? t2.strict ? encodeURIComponent(e2).replaceAll(/[!'()*]/g, (e3) => `%${e3.charCodeAt(0).toString(16).toUpperCase()}`) : encodeURIComponent(e2) : e2;
  }
  function ye(e2, t2) {
    return t2.decode ? se(e2) : e2;
  }
  function he(e2) {
    return Array.isArray(e2) ? e2.sort() : "object" == typeof e2 ? he(Object.keys(e2)).sort((e3, t2) => Number(e3) - Number(t2)).map((t2) => e2[t2]) : e2;
  }
  function me(e2) {
    const t2 = e2.indexOf("#");
    return -1 !== t2 && (e2 = e2.slice(0, t2)), e2;
  }
  function ge(e2, t2, r2) {
    return "string" === r2 && "string" == typeof e2 ? e2 : "function" == typeof r2 && "string" == typeof e2 ? r2(e2) : !t2.parseBooleans || null === e2 || "true" !== e2.toLowerCase() && "false" !== e2.toLowerCase() ? "number" !== r2 || Number.isNaN(Number(e2)) || "string" != typeof e2 || "" === e2.trim() ? t2.parseNumbers && !Number.isNaN(Number(e2)) && "string" == typeof e2 && "" !== e2.trim() ? Number(e2) : e2 : Number(e2) : "true" === e2.toLowerCase();
  }
  function ve(e2) {
    const t2 = (e2 = me(e2)).indexOf("?");
    return -1 === t2 ? "" : e2.slice(t2 + 1);
  }
  function be(e2, t2) {
    _e((t2 = { decode: true, sort: true, arrayFormat: "none", arrayFormatSeparator: ",", parseNumbers: false, parseBooleans: false, types: /* @__PURE__ */ Object.create(null), ...t2 }).arrayFormatSeparator);
    const r2 = function(e3) {
      let t3;
      switch (e3.arrayFormat) {
        case "index":
          return (e4, r3, n3) => {
            t3 = /\[(\d*)]$/.exec(e4), e4 = e4.replace(/\[\d*]$/, ""), t3 ? (void 0 === n3[e4] && (n3[e4] = {}), n3[e4][t3[1]] = r3) : n3[e4] = r3;
          };
        case "bracket":
          return (e4, r3, n3) => {
            t3 = /(\[])$/.exec(e4), e4 = e4.replace(/\[]$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "colon-list-separator":
          return (e4, r3, n3) => {
            t3 = /(:list)$/.exec(e4), e4 = e4.replace(/:list$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "comma":
        case "separator":
          return (t4, r3, n3) => {
            const o2 = "string" == typeof r3 && r3.includes(e3.arrayFormatSeparator), i2 = "string" == typeof r3 && !o2 && ye(r3, e3).includes(e3.arrayFormatSeparator);
            r3 = i2 ? ye(r3, e3) : r3;
            const a2 = o2 || i2 ? r3.split(e3.arrayFormatSeparator).map((t5) => ye(t5, e3)) : null === r3 ? r3 : ye(r3, e3);
            n3[t4] = a2;
          };
        case "bracket-separator":
          return (t4, r3, n3) => {
            const o2 = /(\[])$/.test(t4);
            if (t4 = t4.replace(/\[]$/, ""), !o2) return void (n3[t4] = r3 ? ye(r3, e3) : r3);
            const i2 = null === r3 ? [] : ye(r3, e3).split(e3.arrayFormatSeparator);
            void 0 !== n3[t4] ? n3[t4] = [...n3[t4], ...i2] : n3[t4] = i2;
          };
        default:
          return (e4, t4, r3) => {
            void 0 !== r3[e4] ? r3[e4] = [...[r3[e4]].flat(), t4] : r3[e4] = t4;
          };
      }
    }(t2), n2 = /* @__PURE__ */ Object.create(null);
    if ("string" != typeof e2) return n2;
    if (!(e2 = e2.trim().replace(/^[?#&]/, ""))) return n2;
    for (const o2 of e2.split("&")) {
      if ("" === o2) continue;
      const e3 = t2.decode ? o2.replaceAll("+", " ") : o2;
      let [i2, a2] = pe(e3, "=");
      void 0 === i2 && (i2 = e3), a2 = void 0 === a2 ? null : ["comma", "separator", "bracket-separator"].includes(t2.arrayFormat) ? a2 : ye(a2, t2), r2(ye(i2, t2), a2, n2);
    }
    for (const [e3, r3] of Object.entries(n2)) if ("object" == typeof r3 && null !== r3 && "string" !== t2.types[e3]) for (const [n3, o2] of Object.entries(r3)) {
      const i2 = t2.types[e3] ? t2.types[e3].replace("[]", "") : void 0;
      r3[n3] = ge(o2, t2, i2);
    }
    else "object" == typeof r3 && null !== r3 && "string" === t2.types[e3] ? n2[e3] = Object.values(r3).join(t2.arrayFormatSeparator) : n2[e3] = ge(r3, t2, t2.types[e3]);
    return false === t2.sort ? n2 : (true === t2.sort ? Object.keys(n2).sort() : Object.keys(n2).sort(t2.sort)).reduce((e3, t3) => {
      const r3 = n2[t3];
      return e3[t3] = Boolean(r3) && "object" == typeof r3 && !Array.isArray(r3) ? he(r3) : r3, e3;
    }, /* @__PURE__ */ Object.create(null));
  }
  function Fe(e2, t2) {
    if (!e2) return "";
    _e((t2 = { encode: true, strict: true, arrayFormat: "none", arrayFormatSeparator: ",", ...t2 }).arrayFormatSeparator);
    const r2 = (r3) => t2.skipNull && null == e2[r3] || t2.skipEmptyString && "" === e2[r3], n2 = function(e3) {
      switch (e3.arrayFormat) {
        case "index":
          return (t3) => (r3, n3) => {
            const o3 = r3.length;
            return void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [fe(t3, e3), "[", o3, "]"].join("")] : [...r3, [fe(t3, e3), "[", fe(o3, e3), "]=", fe(n3, e3)].join("")];
          };
        case "bracket":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [fe(t3, e3), "[]"].join("")] : [...r3, [fe(t3, e3), "[]=", fe(n3, e3)].join("")];
        case "colon-list-separator":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [fe(t3, e3), ":list="].join("")] : [...r3, [fe(t3, e3), ":list=", fe(n3, e3)].join("")];
        case "comma":
        case "separator":
        case "bracket-separator": {
          const t3 = "bracket-separator" === e3.arrayFormat ? "[]=" : "=";
          return (r3) => (n3, o3) => void 0 === o3 || e3.skipNull && null === o3 || e3.skipEmptyString && "" === o3 ? n3 : (o3 = null === o3 ? "" : o3, 0 === n3.length ? [[fe(r3, e3), t3, fe(o3, e3)].join("")] : [[n3, fe(o3, e3)].join(e3.arrayFormatSeparator)]);
        }
        default:
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, fe(t3, e3)] : [...r3, [fe(t3, e3), "=", fe(n3, e3)].join("")];
      }
    }(t2), o2 = {};
    for (const [t3, n3] of Object.entries(e2)) r2(t3) || (o2[t3] = n3);
    const i2 = Object.keys(o2);
    return false !== t2.sort && i2.sort(t2.sort), i2.map((r3) => {
      const o3 = e2[r3];
      return void 0 === o3 ? "" : null === o3 ? fe(r3, t2) : Array.isArray(o3) ? 0 === o3.length && "bracket-separator" === t2.arrayFormat ? fe(r3, t2) + "[]" : o3.reduce(n2(r3), []).join("&") : fe(r3, t2) + "=" + fe(o3, t2);
    }).filter((e3) => e3.length > 0).join("&");
  }
  function we(e2, t2) {
    var _a;
    t2 = { decode: true, ...t2 };
    let [r2, n2] = pe(e2, "#");
    return void 0 === r2 && (r2 = e2), { url: ((_a = r2 == null ? void 0 : r2.split("?")) == null ? void 0 : _a[0]) ?? "", query: be(ve(e2), t2), ...t2 && t2.parseFragmentIdentifier && n2 ? { fragmentIdentifier: ye(n2, t2) } : {} };
  }
  function Pe(e2, t2) {
    t2 = { encode: true, strict: true, [de]: true, ...t2 };
    const r2 = me(e2.url).split("?")[0] || "";
    let n2 = Fe({ ...be(ve(e2.url), { sort: false }), ...e2.query }, t2);
    n2 && (n2 = `?${n2}`);
    let o2 = function(e3) {
      let t3 = "";
      const r3 = e3.indexOf("#");
      return -1 !== r3 && (t3 = e3.slice(r3)), t3;
    }(e2.url);
    if ("string" == typeof e2.fragmentIdentifier) {
      const n3 = new URL(r2);
      n3.hash = e2.fragmentIdentifier, o2 = t2[de] ? n3.hash : `#${e2.fragmentIdentifier}`;
    }
    return `${r2}${n2}${o2}`;
  }
  function ke(e2, t2, r2) {
    r2 = { parseFragmentIdentifier: true, [de]: false, ...r2 };
    const { url: n2, query: o2, fragmentIdentifier: i2 } = we(e2, r2);
    return Pe({ url: n2, query: ue(o2, t2), fragmentIdentifier: i2 }, r2);
  }
  const Se = Object.freeze(Object.defineProperty({ __proto__: null, exclude: function(e2, t2, r2) {
    return ke(e2, Array.isArray(t2) ? (e3) => !t2.includes(e3) : (e3, r3) => !t2(e3, r3), r2);
  }, extract: ve, parse: be, parseUrl: we, pick: ke, stringify: Fe, stringifyUrl: Pe }, Symbol.toStringTag, { value: "Module" })), Ce = window.clayStorefrontConfig || {}, xe = window.clayCustomerTags || [], Ae = window.clayProductPriceConfig || {};
  Shopify.theme;
  const Te = window.clayMarketHandle, qe = window.clayCountryCurrency, Ie = window.clayCountryIsoCode, Ne = { productGrid: "product-card", productGridProductUrl: ".product-card__figure a", productGridProductPrice: "price-list", productPagePriceBlock: ".product-info .product-info__price", retailPriceBlockFormatOnProductPage: '<div class="rating-with-text"><price-list class="price-list price-list--lg"><sale-price class="text-lg">{retailPriceText}</sale-price></price-list></div>', retailPriceBlockFormatOnCollectionsPage: '<sale-price class="text-subdued">{retailPriceText}</sale-price>' };
  async function je() {
    re(window.location.href) && async function() {
      var _a;
      let e2 = re(window.location.href);
      const t2 = await ne(e2), r2 = new URL(window.location.href);
      let n2 = Se.parse(r2.search).variant;
      n2 || (n2 = t2[0].id);
      const o2 = t2.find((e3) => e3.id === n2);
      if (!o2.pricingRule) return;
      const i2 = document.querySelector(Ne.productPagePriceBlock);
      i2.getAttribute("data-variant-id") !== o2.id && i2.setAttribute("data-variant-id", "");
      const { retailPrice: a2 } = ee(o2, 1);
      if (!a2 || "" === a2) return;
      let c2 = Z(Number(parseFloat(a2) / 1.21).toFixed(2), Ae.priceDisplayText);
      let l2 = te(Ne.retailPriceBlockFormatOnProductPage, c2, "", "", "");
      i2.classList.contains("clay-wholesale-price") && i2.getAttribute("data-variant-id") === o2.id || (i2.innerHTML = l2, i2.classList.add("clay-wholesale-price"), i2.setAttribute("data-variant-id", o2.id));
      let s2 = i2.querySelector(".clay-savings-text-container");
      s2 && s2.getAttribute("data-variant-id") === o2.id || (s2 = document.createElement("div"), s2.className = "clay-savings-text-container", s2.innerHTML = Ae.savingsDisplayText, s2.setAttribute("data-variant-id", o2.id), i2.appendChild(s2));
      if ("QUANTITY" === o2.pricingRule.markets[0].pricing.type) {
        const e3 = Oe(o2, Ae.quantityGridTemplate);
        if (!e3) return;
        ((_a = e3[0]) == null ? void 0 : _a.price) && e3.forEach((e4) => {
          let t4 = Z(parseFloat(e4.price) / 1.21, Ae.quantityGridPriceDisplayText);
          window.marketConversionRate && (t4 = Z(parseFloat(e4.price) / 1.21, window.clayCurrencySymbol + "{{amount}}")), e4.price = t4;
        });
        let t3 = i2.querySelector(".clay-quantity-grid-table-container");
        t3 && t3.getAttribute("data-variant-id") !== o2.id && (t3.remove(), t3 = null), t3 || (t3 = document.createElement("div"), t3.className = "clay-quantity-grid-table-container", i2.appendChild(t3), D(Re(e3), t3), t3.setAttribute("data-variant-id", o2.id));
      }
    }(), $e(0, 1e4);
  }
  async function Ee() {
    xe && xe.length > 0 && fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { customer_tags: (xe == null ? void 0 : xe.join(",")) || "" } }) }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
    let e2 = null;
    const t2 = await (async (e3, t3, r2) => {
      var _a, _b, _c, _d, _e2, _f, _g, _h;
      let n2 = null, o2 = null, i2 = null, a2 = null;
      try {
        const c2 = await K({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts($country: CountryCode) @inContext(country: $country) {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }", variables: { country: r2 } });
        ((_c = (_b = (_a = c2 == null ? void 0 : c2.data) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) == null ? void 0 : _c.length) > 0 && (n2 = (_d = c2.data.products.edges[0].node.variants) == null ? void 0 : _d.edges[0].node.price);
        const l2 = await K({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }" });
        if (((_g = (_f = (_e2 = l2 == null ? void 0 : l2.data) == null ? void 0 : _e2.products) == null ? void 0 : _f.edges) == null ? void 0 : _g.length) > 0 && (o2 = (_h = l2.data.products.edges[0].node.variants) == null ? void 0 : _h.edges[0].node.price), n2 && o2) {
          const e4 = o2.currencyCode;
          e4 !== n2.currencyCode && (a2 = (parseFloat(n2.amount) / parseFloat(o2.amount)).toFixed(8), i2 = e4);
        }
        return { conversionRate: a2, baseCurrency: i2 };
      } catch (e4) {
        return console.error("Error fetching conversion rate:", e4), { conversionRate: null, baseCurrency: null };
      }
    })(Ce.shopDomain, Ce.token, Ie);
    t2.conversionRate && (e2 = { conversion_rate: t2.conversionRate, base_currency: t2.baseCurrency, market_handle: Te, market_currency: qe }), window.marketConversionRate = e2, e2 && fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { market_conversion_rate: JSON.stringify(e2) } }) }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
  }
  function $e(e2, t2, r2) {
    let n2 = document.querySelectorAll(Ne.productGrid);
    !function(e3) {
      e3.forEach(async (e4, t3) => {
        var _a;
        const r3 = (_a = e4.querySelector(Ne.productGridProductUrl)) == null ? void 0 : _a.href;
        if (!r3) return;
        let n3 = re(r3);
        const o2 = e4.querySelector(Ne.productGridProductPrice);
        if (!o2 || o2.classList.contains("clay-wholesale-price")) return;
        !async function(e5, t4, r4) {
          e5.sort((e6, t5) => parseFloat(e6.price.amount) - parseFloat(t5.price.amount));
          const n4 = e5[0];
          if (!n4.pricingRule) return;
          const o3 = t4.querySelector(r4.productGridProductPrice), { retailPrice: i2 } = ee(n4, 1);
          if (!i2 || "" === i2) return;
          let a2 = Z(Number(parseFloat(i2) / 1.21).toFixed(2), Ae.priceDisplayText);
          let c2 = te(r4.retailPriceBlockFormatOnCollectionsPage, a2, "", "", "");
          o3.classList.contains("clay-wholesale-price") || (o3.innerHTML = c2, o3.classList.add("clay-wholesale-price"));
        }(await ne(n3), e4, Ne);
      });
    }(n2), e2 < t2 && setTimeout(() => {
      $e(e2 + 200, t2, n2.length);
    }, 200);
  }
  !async function() {
    await Ee(), function() {
      window.addEventListener("popstate", je);
      const e2 = history.pushState;
      history.pushState = function() {
        e2.apply(this, arguments), je();
      };
      const t2 = history.replaceState;
      history.replaceState = function() {
        t2.apply(this, arguments), je();
      }, je();
    }();
  }();
  const Oe = (e2, t2) => {
    let r2 = e2.pricingRule.markets[0], n2 = r2.pricing.strategy, o2 = r2.pricing.values.map((e3) => ({ ...e3 })), i2 = r2.currency, a2 = e2.price.currencyCode, c2 = "R" === r2.pricing.priceSource ? e2.price.amount : e2.compareAtPrice.amount, l2 = window.marketConversionRate;
    if ("" === i2 && l2 && l2.base_currency !== a2) return null;
    if (!c2 || "" === c2) return null;
    switch (i2 !== a2 && "" !== i2 && l2 && l2.conversion_rate && ["A", "F"].includes(n2) && o2.forEach((e3) => {
      e3.price = (parseFloat(e3.price) * l2.conversion_rate).toFixed(2).toString();
    }), o2.forEach((t3) => {
      let r3 = "A" === n2 ? t3.price : "P" === n2 ? (parseFloat(c2) * (1 - parseFloat(t3.price) / 100)).toFixed(2).toString() : "F" === n2 ? (parseFloat(c2) - parseFloat(t3.price)).toFixed(2).toString() : e2.price.amount;
      (parseFloat(r3) < 0 || parseFloat(r3) > parseFloat(e2.price.amount)) && (r3 = e2.price.amount), t3.price = r3;
    }), t2) {
      case "quantityPrice":
        return o2.map((e3) => ({ quantity: e3.quantity, price: parseFloat(e3.price).toFixed(2) }));
      case "quantityRangePrice":
        return o2.map((e3, t3, r3) => t3 === r3.length - 1 ? { range: `${e3.quantity}+`, price: parseFloat(e3.price).toFixed(2) } : { range: `${e3.quantity}-${r3[t3 + 1].quantity - 1}`, price: parseFloat(e3.price).toFixed(2) });
      case "quantityRangeDiscount":
        return o2.map((e3, t3, r3) => t3 === r3.length - 1 ? { range: `${e3.quantity}+`, discount: ((parseFloat(c2) - parseFloat(e3.price)) / parseFloat(c2) * 100).toFixed(0) + "%" } : { range: `${e3.quantity}-${r3[t3 + 1].quantity - 1}`, discount: ((parseFloat(c2) - parseFloat(e3.price)) / parseFloat(c2) * 100).toFixed(0) + "%" });
      case "quantityBuyPrice":
        return o2.map((e3) => ({ quantity: "Buy " + e3.quantity, price: parseFloat(e3.price).toFixed(2) }));
      case "quantityPriceDiscount":
        return o2.map((e3) => ({ quantity: e3.quantity, price: parseFloat(e3.price).toFixed(2), discount: ((parseFloat(c2) - parseFloat(e3.price)) / parseFloat(c2) * 100).toFixed(0) + "%" }));
      default:
        return [];
    }
  }, Re = (e2) => {
    let t2 = "";
    switch (Ae.quantityGridTemplate) {
      case "quantityPrice":
        t2 = U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Hoeveelheid" }), U("th", { children: "Prijs" })] }) }), U("tbody", { children: e2.map((e3, t3) => U("tr", { children: [U("td", { children: e3.quantity }), U("td", { children: e3.price })] }, t3)) })] });
      case "quantityRangePrice":
        t2 = U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Hoeveelheid" }), U("th", { children: "Prijs" })] }) }), U("tbody", { children: e2.map((e3, t3) => U("tr", { children: [U("td", { children: e3.range }), U("td", { children: e3.price })] }, t3)) })] });
      case "quantityRangeDiscount":
        t2 = U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Hoeveelheid" }), U("th", { children: "Korting" })] }) }), U("tbody", { children: e2.map((e3, t3) => U("tr", { children: [U("td", { children: e3.range }), U("td", { children: e3.discount })] }, t3)) })] });
      case "quantityBuyPrice":
        t2 = U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Hoeveelheid" }), U("th", { children: "Prijs" })] }) }), U("tbody", { children: e2.map((e3, t3) => U("tr", { children: [U("td", { children: e3.quantity }), U("td", { children: e3.price })] }, t3)) })] });
      case "quantityPriceDiscount":
        t2 = U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Hoeveelheid" }), U("th", { children: "Prijs" }), U("th", { children: "Korting" })] }) }), U("tbody", { children: e2.map((e3, t3) => U("tr", { children: [U("td", { children: e3.quantity }), U("td", { children: e3.price }), U("td", { children: e3.discount })] }, t3)) })] });
    }
    return t2;
  };
}();
